import type { WithTypename } from "@urql/exchange-graphcache"
import { graphql } from "@/graphql"
import type {
  GraphCacheOptimisticUpdaters,
  PublishedPost,
} from "@/graphql/generated"

const PostReactionsFragment = graphql(`
  fragment PostReactionsFragment on PublishedPost @_unmask {
    id
    reactions {
      __typename
      emoji
      count
      reacted
    }
  }
`)

export const reactionsOptimisticUpdaters = {
  toggleReaction: (variables, cache) => {
    const post = cache.readFragment(PostReactionsFragment, {
      __typename: "PublishedPost",
      id: variables.postId,
    })

    const oldReactions = post?.reactions ?? []

    const newReactions = oldReactions.map(r =>
      r.emoji === variables.emoji
        ? {
            ...r,
            reacted: !r.reacted,
            count: r.reacted ? r.count - 1 : r.count + 1,
          }
        : {
            ...r,
            reacted: false,
            count: r.reacted ? r.count - 1 : r.count,
          },
    )

    if (!newReactions.find(r => r.emoji === variables.emoji)) {
      newReactions.push({
        __typename: "ReactionSummary",
        emoji: variables.emoji,
        reacted: true,
        count: 1,
      })
    }

    return {
      __typename: "PublishedPost",
      id: variables.postId,
      reactions: newReactions,
    } as unknown as WithTypename<PublishedPost>
  },
} satisfies GraphCacheOptimisticUpdaters
